import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@strava/ui/Button';
import { Modal } from '@strava/ui/Modal';

import styles from './styles.scss';

const BaseModal = ({
  children,
  onSubmit = () => {},
  onDismiss = () => {},
  isSaving = false,
  hasChanges = false,
  title,
  buttonLabels,
  isOpen = false,
  hideSaveBtn = false
}) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onDismiss();
        }
      }}
      popupProps={{
        className: styles.modal
      }}
      shouldRenderTriggerButton={false}
      shouldShowCloseButtonIcon={true}
      zIndex={5000}
      maxWidth="800px"
    >
      <Modal.Content
        aria-labelledby="photo-lightbox-modal-title"
        className={styles.content}
        data-testid="modal-content"
      >
        <Modal.Title data-testid="title" id="photo-lightbox-modal-title">
          {title}
        </Modal.Title>

        <Modal.Body className={styles.body}>
          <form onSubmit={onSubmit}>
            {children}
            {!hideSaveBtn && (
              <Button
                variant="primary"
                data-testid="save-button"
                className={styles.saveBtn}
                disabled={isSaving || !hasChanges}
              >
                {/* eg. "Saving..." vs "Save" button labels */}
                {isSaving
                  ? buttonLabels.isSavingText || 'Saving...'
                  : buttonLabels.saveText || 'Save'}
              </Button>
            )}
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

BaseModal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
  isSaving: PropTypes.bool,
  hasChanges: PropTypes.bool,
  title: PropTypes.string.isRequired,
  buttonLabels: PropTypes.shape({
    saveText: PropTypes.string,
    isSavingText: PropTypes.string
  }).isRequired,
  hideSaveBtn: PropTypes.bool
};

export default BaseModal;
